import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../app/Store";
import { selectApplicationSessionEpoch } from "../app/store/applicationSessionStore";
import { clearSubscriptions, fetchSubscriptions } from "./SubscriptionsStore";

export const SUBSCRIPTIONS_REFRESH_INTERVAL_MS = 2 * 60 * 1000;

export default function useSubscriptions(siteIds: string[]) {
  const dispatch = useDispatch<AppDispatch>();
  const epoch = useSelector(selectApplicationSessionEpoch);
  useEffect(() => {
    dispatch(clearSubscriptions());
    if (siteIds.length === 0) {
      return;
    }
    let request: ReturnType<ReturnType<typeof fetchSubscriptions>> | undefined;
    const refresh = () => {
      request?.abort();
      request = dispatch(fetchSubscriptions());
    };
    refresh();
    const interval = setInterval(refresh, SUBSCRIPTIONS_REFRESH_INTERVAL_MS);
    return () => {
      clearInterval(interval);
      request?.abort();
      dispatch(clearSubscriptions());
    };
  }, [dispatch, siteIds, epoch]);
}
